import qrcode from 'qrcode-generator';

const QR_SELECTOR = 'img[data-totp-uri], .form-2fa img';

const uriOf = (img) => {
    if (img.hasAttribute('data-totp-uri')) return img.getAttribute('data-totp-uri');

    // Compatibility with message_totp_enable() until PHP stops emitting external src.
    const src = img.getAttribute('src');
    if (!src) return null;
    try {
        const url = new URL(src, document.baseURI);
        if (url.hostname !== 'api.qrserver.com' ||
            url.pathname.replace(/\/$/, '') !== '/v1/create-qr-code') return null;
        return url.searchParams.get('data') || '';
    } catch {
        return null;
    }
};

const localQrSource = (uri) => {
    // URI parsing also percent-encodes Unicode labels before the QR byte encoder.
    if (!uri || uri.length > 2048) throw new Error('Invalid TOTP URI');
    const url = new URL(uri);
    const secret = url.searchParams.get('secret') || '';
    if (url.protocol !== 'otpauth:' || url.hostname !== 'totp' ||
        url.pathname.length < 2 || url.username || url.password ||
        !/^[A-Z2-7]+={0,6}$/i.test(secret)) throw new Error('Invalid TOTP URI');

    const qr = qrcode(0, 'M');
    qr.addData(url.href, 'Byte');
    qr.make();
    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(qr.createSvgTag(4, 16));
};

export const renderTotpQr = (root = document) => {
    root.querySelectorAll(QR_SELECTOR).forEach(img => {
        const uri = uriOf(img);
        if (uri === null) return;

        // Remove the external URL even on failure. Never fall back to the QR service.
        img.removeAttribute('src');
        img.removeAttribute('srcset');
        img.removeAttribute('data-totp-uri');
        try {
            img.src = localQrSource(uri);
            if (!img.hasAttribute('width')) img.width = 200;
            if (!img.hasAttribute('height')) img.height = 200;
            if (!img.hasAttribute('alt')) img.alt = 'TOTP QR';
        } catch {
            // The manually readable secret in the setup form remains available.
            // Do not log the URI, secret, or library exception containing QR data.
            img.hidden = true;
        }
    });
};

export const prepareTotpQrHtml = (html) => {
    if (typeof html !== 'string' || !/qrserver\.com|data-totp-uri/i.test(html)) return html;

    // Template contents are inert. A detached img or a MutationObserver is too late:
    // the browser can start loading an external src as soon as it is assigned.
    const template = document.createElement('template');
    template.innerHTML = html;
    renderTotpQr(template.content);
    return template.innerHTML;
};
